import SelectList from "types/SelectList";

const LANGUAGES_LIST: SelectList = [
  { value: "pt", label: "🇧🇷 - Português" },
  { value: "en", label: "🇺🇸 - English" },
  { value: "es", label: "🇪🇸 - Español" },
];
export default LANGUAGES_LIST;
